"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createOrUpdateFocusedOtherOverrideOperation_1 = require("owa-service/lib/operation/createOrUpdateFocusedOtherOverrideOperation");
var Utils_1 = require("owa-service/lib/Utils");
/**
 * Create or Update Focused Other override action service
 * @param senderSMTPAddress sender SMTP address
 * @param inferenceClassification the inferenceClassification
 * @return the CreateOrUpdateFocusedOtherOverrideResponse
 */
function createOrUpdateFocusedOtherOverrideService(senderSMTPAddress, inferenceClassification) {
    var requestBody = {
        SenderSmtpAddress: senderSMTPAddress,
        AlwaysClassifyAs: inferenceClassification,
    };
    return createOrUpdateFocusedOtherOverrideOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
exports.createOrUpdateFocusedOtherOverrideService = createOrUpdateFocusedOtherOverrideService;
//# sourceMappingURL=createOrUpdateFocusedOtherOverrideService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/createOrUpdateFocusedOtherOverrideService.js
// module id = 5631
// module chunks = 62